/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RewardCreateRequest } from './rewardCreateRequest';


export interface AwardStrategyRequest { 
    id?: number;
    type: AwardStrategyRequest.TypeEnum;
    awardDataValue?: string;
    rewards: Array<RewardCreateRequest>;
}
export namespace AwardStrategyRequest {
    export type TypeEnum = 'REWARD_ONLY_AWARD' | 'HAPPY_HOUR_AWARD' | 'SOCIAL_NETWORK_POST_AWARD' | 'TERM_AWARD';
    export const TypeEnum = {
        RewardOnlyAward: 'REWARD_ONLY_AWARD' as TypeEnum,
        HappyHourAward: 'HAPPY_HOUR_AWARD' as TypeEnum,
        SocialNetworkPostAward: 'SOCIAL_NETWORK_POST_AWARD' as TypeEnum,
        TermAward: 'TERM_AWARD' as TypeEnum
    };
}


